/**
 *
 * @module entry
 * @desc {SDK.Token} entry point.
 *
 */

import GeoLocation from './geoLocation';
import GeoProvider from './../platforms/geoProvider';

import TokenManager from './tokenManager';
import TokenRefreshFailure from './tokenRefreshFailure';
import AccessStorage from './accessStorage';
import DeviceGrantStorage from './deviceGrantStorage';
import AccessContextState from './accessContextState';
import Access from './access';
import AccessTokenProvider from './accessTokenProvider';
import AccessTokenUpdater from './accessTokenUpdater';
import AccessToken from './accessToken';
import AccessState from './accessState';
import AccessStateData from './accessStateData';
import IdentityTokenStorage from './identityTokenStorage';

/**
 *
 * @typedef SDK.Token
 * @type {Object}
 *
 * @property {GeoLocation} GeoLocation
 * @property {GeoProvider} GeoProvider
 *
 * @property {TokenManager} TokenManager
 * @property {TokenRefreshFailure} TokenRefreshFailure
 * @property {AccessStorage} AccessStorage
 * @property {DeviceGrantStorage} DeviceGrantStorage
 * @property {AccessContextState} AccessContextState
 * @property {Access} Access
 * @property {AccessTokenProvider} AccessTokenProvider
 * @property {AccessTokenUpdater} AccessTokenUpdater
 * @property {AccessToken} AccessToken
 * @property {GeoProvider} GeoProvider
 * @property {GeoLocation} GeoLocation
 * @property {AccessState} AccessState
 * @property {AccessStateData} AccessStateData
 * @property {IdentityTokenStorage} IdentityTokenStorage
 *
 */

/**
 *
 * @type {SDK.Token}
 *
 */
export default {

    GeoLocation,
    GeoProvider,

    TokenManager,
    TokenRefreshFailure,
    AccessStorage,
    DeviceGrantStorage,
    AccessContextState,
    Access,
    AccessTokenProvider,
    AccessTokenUpdater,
    AccessToken,
    AccessState,
    AccessStateData,
    IdentityTokenStorage

};



// WEBPACK FOOTER //
// ./src/token/entry.js